import React, { useEffect, useState } from "react";
import { Check, Trash2, Loader2, MessageSquare } from "lucide-react";
import api from "../api";
import { Button } from "../components/ui/button";
import { useToast } from "../hooks/use-toast";

export default function CommentsPanel() {
  const { toast } = useToast();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/comments").then((r) => setComments(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const approve = async (id) => { await api.post(`/admin/comments/${id}/approve`); toast({ title: "Comment approved" }); load(); };
  const del = async (id) => { await api.delete(`/admin/comments/${id}`); toast({ title: "Comment deleted" }); load(); };

  const pending = comments.filter((c) => !c.approved);
  const approved = comments.filter((c) => c.approved);

  const Row = ({ c }) => (
    <div className="bg-[#161618] border border-[#26262a] rounded-lg px-5 py-4">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-widest text-gray-500">{c.post_title}</p>
          <p className="font-semibold text-white mt-0.5">{c.name}</p>
          <p className="text-gray-300 mt-1 whitespace-pre-wrap">{c.body}</p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {!c.approved && (
            <Button size="sm" onClick={() => approve(c.id)} className="bg-green-600 hover:bg-green-700 text-white" title="Approve"><Check className="w-4 h-4" /></Button>
          )}
          <Button size="sm" variant="outline" onClick={() => del(c.id)} className="border-[#2a2a2e] bg-transparent text-red-400 hover:bg-red-500/10 hover:text-red-300" title="Delete"><Trash2 className="w-4 h-4" /></Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="mt-12">
      <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <MessageSquare className="w-5 h-5 text-[#e63946]" /> Comments
        {pending.length > 0 && <span className="text-xs bg-[#e63946] text-white rounded-full px-2 py-0.5">{pending.length} pending</span>}
      </h2>
      {loading ? (
        <Loader2 className="w-6 h-6 animate-spin text-[#e63946]" />
      ) : (
        <div className="space-y-6">
          <div>
            <h3 className="text-sm uppercase tracking-widest text-gray-500 mb-3">Pending approval</h3>
            {pending.length === 0 ? <p className="text-gray-600 text-sm">Nothing pending.</p> : <div className="space-y-3">{pending.map((c) => <Row key={c.id} c={c} />)}</div>}
          </div>
          {approved.length > 0 && (
            <div>
              <h3 className="text-sm uppercase tracking-widest text-gray-500 mb-3">Approved (live)</h3>
              <div className="space-y-3">{approved.map((c) => <Row key={c.id} c={c} />)}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
